const baseURL = 'https://vcards.gdar.com.mx/api';
//https://vcards.gdar.com.mx/api/empresasUsuario/obtenerDatosEmpresaEncriptado/hF8XeVIn5W3wsBBASdT88g%253d%3D/wEw1nTGMyIQ%3d
export const fetchSinToken = async (ruta: string, datos: any = null, method = 'GET') => {
  const url = `${baseURL}/${ruta}`;

  try {
    let repuesta;
    if (method == 'GET') {
      repuesta = await fetch(url);
    } else {
      repuesta = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(datos),
      });
    }

    return repuesta;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

export const fetchConToken = async (ruta: string, datos: any = null, method: string) => {
  const url = `${baseURL}/${ruta}`;

  try {
    const storedData = localStorage.getItem('token');
    let tokenValue = '';
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      tokenValue = Object.values(parsedData).join('');
    }

    let respuesta;

    const esFormData = datos instanceof FormData;

    const opcionesRequestPOST = {
      method,
      headers: {
        'Authorization': `Bearer ${tokenValue}`,
        ...(esFormData ? {} : { 'Content-Type': 'application/json' })
      },
      body: esFormData ? datos : JSON.stringify(datos),
    };

    const opcionesRequestGET = {
      method,
      headers: {
        'Authorization': `Bearer ${tokenValue}`,
        'Content-Type': 'application/json',
      },
    };
    if (method === 'GET') {
      respuesta = await fetch(url, opcionesRequestGET);
    } else {
      respuesta = await fetch(url, opcionesRequestPOST);
    }

  
    return respuesta;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};
